import { render, staticRenderFns } from "./zzjg.vue?vue&type=template&id=1e846e02&scoped=true"
import script from "./zzjg.vue?vue&type=script&lang=js"
export * from "./zzjg.vue?vue&type=script&lang=js"
import style0 from "./zzjg.vue?vue&type=style&index=0&id=1e846e02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e846e02",
  null
  
)

export default component.exports